export const startInstance = undefined
export const getRouter = () => {}
